import activities from "./activities";

const activitiesReducer = {
  activities
};

export default activitiesReducer;
